import { createContextFromValue } from '@99designs/design-services-common';

export type EnvironmentConfig = {
    private: {
        graphqlHost: string;
    };
    public: {
        environment: string;
        bugsnagApiKey: string;
        bugsnagReleaseStage: string;
        enableTranslationDebug?: boolean;
    };
};
export const defaultEnvironmentConfig: EnvironmentConfig = {
    private: {
        // Only ever used in server-side code, not exposed to the client
        graphqlHost: '',
    },
    public: {
        // Public environment variables that can be used in client-side code
        // Do not include sensitive information here
        environment: '',
        bugsnagApiKey: '',
        bugsnagReleaseStage: '',
        enableTranslationDebug: false,
    },
};

export const { Provider: EnvironmentConfigProvider, useValue: useEnvironment } =
    createContextFromValue('EnvironmentContext', defaultEnvironmentConfig.public);
